'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Tab(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['active', 'disabled', 'className', 'children']);

  var classes = (0, _classnames2.default)('tabs__tab', active && 'tabs__tab--active', disabled && 'tabs__tab--disabled', className);

  return _react2.default.createElement(
    'li',
    _extends({ className: classes }, props),
    children
  );
}

Tab.propTypes = {
  active: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = Tab;